module.exports = __webpack_public_path__ + "img/index_code.1a1daf62.jpg";